import {loadCSS} from './injectCSS';

export function loadTheme(options) {
  const themeId = (options && options.themeId) || 'brandwatch-dark';
  loadCSS(new URL(`/${themeId}/theme.next.css`, window.env.THEMES_URL).href);
}
